function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { useEffect } from 'react';
import { useScrollTo } from '@bydesign-ui/hooks';
import { AnchorItem } from '../../../models/anchor';
import { useAnchor } from './useAnchor';
import { useParentAnchorItem } from './useParentAnchorItem';
export function useAnchorItem(href, id) {
  var anchor = useAnchor();
  var parent = useParentAnchorItem();
  var anchorItem = useSingleton(function () {
    return new AnchorItem(anchor, parent, id);
  });
  anchorItem.updateOptions({
    href: href
  });
  var update = useUpdate();
  useEffect(function () {
    var status = anchorItem.updateOffsetTop();
    status && update();
  }, [anchor.getContainer(), href]);
  useEffect(function () {
    anchor.addListener('active-item', update);
    return function () {
      anchor.removeListener('active-item', update);
      anchorItem.dispose();
    };
  }, []);
  var scrollToResult = useScrollTo(anchor.getContainer(), 'top', function () {
    anchorItem.updateOffsetTop();
    return anchorItem.getOffsetTop() - anchor.getTargetOffset();
  }, 300, function () {
    return !!anchor.getContainer();
  }, {
    start: function start() {
      anchor.setScrolling(true);
    },
    end: function end() {
      anchor.setScrolling(false);
    }
  });
  return _objectSpread({
    anchorItem: anchorItem,
    level: anchorItem.getLevel(),
    isActive: anchorItem.getId() === anchor.getActiveId() || !anchor.hasItemId(anchorItem.getId()) && typeof window !== 'undefined' && window.location.hash === href,
    activeDot: anchor.getActiveDot(),
    hashLink: anchor.getHashLink()
  }, scrollToResult);
}